import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 计算 performance 相关
 */

import { getPerformanceTimingData } from "./base";
import { getLongTaskEntries } from "./longtask";
import { fix } from "../../utils";
var _performanceCursor = 0;
var _longTaskCursor = 0;
export var startPerformance = function startPerformance(task) {
  var timeOrigin = task.ctx.timeOrigin;
  if (!window.performance || !window.performance.getEntries || !timeOrigin) {
    return;
  }

  // performanceEntries
  var performanceEntries = performance.getEntries();
  var ps = performanceEntries.slice(_performanceCursor);
  // console.log('ps', _performanceCursor, ps, performanceEntries)
  formatResourceEntries(task, ps);

  // longTaskEntries
  var longTaskEntries = getLongTaskEntries();
  var ts = longTaskEntries.slice(_longTaskCursor);
  formatLongTaskEntries(task, ts);

  // 防止重复统计
  _performanceCursor = Math.max(performanceEntries.length - 1, 0);
  _longTaskCursor = Math.max(longTaskEntries.length - 1, 0);

  // 获取 Timing 参数
  getPerformanceTimingData(task);

  // todo: 获取更多 Navigator 相关参数, ttfb
  // getNavigatorData(task)
};
// todo: 后续和 rd 沟通把 longtask 相关统计也加上
export var formatLongTaskEntries = function formatLongTaskEntries(task, entries) {
  var _task$ctx = task.ctx,
    state = _task$ctx.state,
    startTimestamp = _task$ctx.startTimestamp,
    timeOrigin = _task$ctx.timeOrigin;

  // const result = {}

  entries.forEach(function (v) {
    if (state === 'navigation' && timeOrigin + v.startTime < startTimestamp) {
      return;
    }
    // todo: 类似统计 资源信息方式，统计 longtask
  });
};

// 序列化所有的静态资源信息
// 后面可以考虑优化到后端去， 这种不能很好支持分段上报
var isJsonp = function isJsonp(name) {
  return /app\.zhuanzhuan\.com\//.test(name) && /callback\=/.test(name);
};
var formatEntryName = function formatEntryName(name) {
  try {
    var _URL = new URL(name),
      hostname = _URL.hostname,
      path = _URL.path;
    return "".concat(hostname).concat(path);
  } catch (error) {
    console.log(error);
  }
  return name;
};
// TODO: 优化 name 去除 query hash
var getResultByResource = function getResultByResource() {
  var entry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseStartTime = arguments.length > 1 ? arguments[1] : undefined;
  // console.log('fstart', entry?.requestStart - baseStartTime, entry?.fetchStart - baseStartTime)
  var res = {
    start: fix((entry === null || entry === void 0 ? void 0 : entry.fetchStart) - baseStartTime || 0),
    fstart: fix((entry === null || entry === void 0 ? void 0 : entry.fetchStart) - baseStartTime || 0),
    end: fix((entry === null || entry === void 0 ? void 0 : entry.responseEnd) - baseStartTime || 0),
    name: formatEntryName(entry === null || entry === void 0 ? void 0 : entry.name)
  };
  return res;
};
var classResource = function classResource(result) {
  // console.log('classResource', result)
  var res = {
    ajax: [],
    ajaxMax: 0,
    ajaxMin: 0,
    ajaxTime: 0,
    //
    source: [],
    sourceMax: 0,
    sourceMin: 0,
    sourceTime: 0,
    //
    imgs: [],
    imgsMax: 0,
    imgsMin: 0,
    imgsTime: 0,
    domain: []
  };
  res.ajax = result.ajax.map(function (v) {
    return "".concat(v.name, "|").concat(v.start, "|").concat(v.fstart, "|").concat(v.end, "|", true);
  });
  res.ajaxMax = fix(Math.max.apply(Math, _toConsumableArray(result.ajaxMax)));
  res.ajaxMin = fix(Math.min.apply(Math, _toConsumableArray(result.ajaxMin)));
  res.ajaxTime = fix(res.ajaxMax - res.ajaxMin) || 0;
  //
  res.source = result.source.map(function (v) {
    return "".concat(v.name, "|").concat(v.start, "|").concat(v.fstart, "|").concat(v.end, "|", true);
  });
  res.sourceMax = fix(Math.max.apply(Math, _toConsumableArray(result.sourceMax)));
  res.sourceMin = fix(Math.min.apply(Math, _toConsumableArray(result.sourceMin)));
  res.sourceTime = fix(res.sourceMax - res.sourceMin);
  //
  res.imgs = result.imgs.map(function (v) {
    return "".concat(v.name, "|").concat(v.start, "|").concat(v.fstart, "|").concat(v.end, "|", true);
  });
  res.imgsMax = fix(Math.max.apply(Math, _toConsumableArray(result.imgsMax)));
  res.imgsMin = fix(Math.min.apply(Math, _toConsumableArray(result.imgsMin)));
  res.imgsTime = fix(res.imgsMax - res.imgsMin);
  return res;
};
export var formatResourceEntries = function formatResourceEntries(task, entries) {
  var _task$ctx2 = task.ctx,
    state = _task$ctx2.state,
    startTimestamp = _task$ctx2.startTimestamp,
    timeOrigin = _task$ctx2.timeOrigin;
  var metrics = task.metrics;
  var result = {
    ajax: [],
    ajaxMax: [],
    ajaxMin: [],
    source: [],
    sourceMax: [],
    sourceMin: [],
    imgs: [],
    imgsMax: [],
    imgsMin: [],
    domain: []
  };
  entries.forEach(function (entry) {
    var startTime = entry.startTime;
    // console.log( timeOrigin, startTime, startTimestamp, timeOrigin + startTime < startTimestamp)
    if (state === 'navigation' && timeOrigin + startTime < startTimestamp) {
      return;
    }
    var baseStartTime = startTimestamp - timeOrigin;
    switch (entry.entryType) {
      case 'navigation':
        {
          metrics['bodysize'] = (entry === null || entry === void 0 ? void 0 : entry.decodedBodySize) || 0;
          calcResource(entry, result, baseStartTime);
          break;
        }
      case 'paint':
        {
          if (entry.name === 'first-paint') {
            // firstPiantTime 为旧数据字段 先保留
            metrics['firstPiantTime'] = parseInt(entry === null || entry === void 0 ? void 0 : entry.startTime.toString(), 10);
            metrics['fp'] = parseInt(entry === null || entry === void 0 ? void 0 : entry.startTime.toString(), 10);
          }
          if (entry.name === 'first-contentful-paint') {
            metrics['fcp'] = parseInt(entry === null || entry === void 0 ? void 0 : entry.startTime.toString(), 10);
          }
          break;
        }
      case 'resource':
        {
          // initiatorType: 'link' | 'script' | 'fetch' | 'xmlhttprequest' | 'img' | 'css' | 'iframe';
          calcResource(entry, result, baseStartTime);
          break;
        }
      default:
        {}
    }
  });
  function calcResource(entry, result, baseStartTime) {
    // console.log('calcResource', entry, result)
    var item = getResultByResource(entry, baseStartTime);
    switch (entry === null || entry === void 0 ? void 0 : entry.initiatorType) {
      case 'beacon':
      case 'xmlhttprequest':
        result.ajaxMax.push(item.end > 0 ? item.end : 0);
        result.ajaxMin.push(item.start > 0 ? item.start : 0);
        result.ajax.push(item);
        // needAjax && result.ajax.push(item);
        break;
      case 'img':
      case 'css':
        if (/\.jpg|\.jpeg|\.png|\.svg|\.gif|\.webp/i.test(item.name)) {
          result.imgsMax.push(item.end > 0 ? item.end : 0);
          result.imgsMin.push(item.start > 0 ? item.start : 0);
          result.imgs.push(item);
          // needImg && result.imgs.push(item);
        }
        break;
      case 'link':
      case 'script':
        if (isJsonp(item.name)) {
          result.ajaxMax.push(item.end > 0 ? item.end : 0);
          result.ajaxMin.push(item.start > 0 ? item.start : 0);
          result.ajax.push(item);
          break;
        }
      default:
        {
          result.sourceMax.push(item.end > 0 ? item.end : 0);
          result.sourceMin.push(item.start > 0 ? item.start : 0);
          result.source.push(item);
          break;
        }
    }
  }
  var res = classResource(result);
  Object.assign(metrics, _objectSpread({}, res));
  return res;
};